<template>
  <v-dialog v-model="show" max-width="500px" @keydown.enter="addItem">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">Lisää tukkuri</span>
      </v-card-title>
      <v-container grid-list-md class="pt-0 pb-0 add-product-container">
        <v-row wrap>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.name"  autofocus label="Tukkurin nimi*" required></v-text-field>
          </v-col>
          <!-- <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.wholesaleCode" label="Avecor koodi (kolme kirjainta)"  :counter="3" maxlength="3"></v-text-field>
          </v-col> -->
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.language" label="Kieli" ></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.webAddress" label="Tukkurin web-osoite"></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.webAddress2" label="Tukkurin toinen web-osoite"></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0 my-0">
            <v-text-field v-model="newItem.orderEmail" label="Tilaussähköpostiosoite" required></v-text-field>
          </v-col>
          
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.username" label="Käyttäjätunnus" required></v-text-field>
          </v-col>        
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.password" label="Salasana" required></v-text-field>
          </v-col>
          <v-col cols="12" class="mb-3">
            <span style="font-size:13px"><i>Tukkurin kontaktit voit lisätä sen jälkeen kun tukkuri on lisätty.</i></span>
          </v-col>
          <!-- <v-col cols="6">
            <v-checkbox 
              label="Ovatko tuotteet katalogissa?"
              v-model="newItem.productsInCatalog" 
              class="avecor-table-checkbox">
            </v-checkbox>
          </v-col> -->
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2" text @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" text @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props:['visible'],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
       newItem: {
        name: '',
        language:'',
        wholesaleCode:'',
        webAddress: '',
        webAddress2:'',
        productsInCatalog: '',
        orderEmail: '',
        username: '',
        password: ''

      },
      defaultItem: {
        name: '',
        language:'',
        wholesaleCode:'',
        webAddress: '',
        webAddress2:'',
        productsInCatalog: '',
        orderEmail: '',
        username: '',
        password: ''
      },   
    }),
    mounted() {
    },
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
          if (!value) {
            this.$emit('close')
          }
        }
      },
      ...mapFields({
        staff:'staff.staff',
        settings:'settings',
        user:'user',
        selectedWholesaleCompanyIdInPartners:"views.partners.selectedWholesaleCompany.wholesaleCompanyId",
      }),
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.show = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.newItem.name === '') {alert("Täytä *-kentät"); return}
        var t = this
        let {id, ...y} = this.newItem;
        const newId = await this.$store.dispatch('wholesaleCompany/set', {
          id,
          ...y
        }).then(v => {
          t.selectedWholesaleCompanyIdInPartners = null
          setTimeout(() => {t.selectedWholesaleCompanyIdInPartners = v}, 1000);
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Lisätty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
        this.close()
      },
      inlineCancel () {
      },
      inlineOpen () {
      },
      inlineClose () {
        //console.log('Dialog closed')
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddWholesaleCompany.vue